<template>
    <div>
        <div class="mb-1" v-for="(v, i) in splitValues" :key="i">

            <div class="input-group">
                <input 
                :type="type" 
                :placeholder="placeholder" 
                :value="v" 
                :pattern="pattern.source" 
                @input="updateValue(i, $event.target)" 
                class="form-control"
                :aria-describedby="'button-addon_' + i"/>
                 <div class="input-group-append" :id="'button-addon_' + i">
                   <button class="btn btn-outline-secondary" type="button" @click="doRemove(i)">-</button>
                   <button class="btn btn-outline-secondary" type="button" @click="doAdd(i)">+</button>
                 </div>
            </div>

        </div>
        <div class="invalid-feedback" :class="{'d-block': !allInputsValid}">
            Bitte geben Sie die Telefonnummer im internationalen Format +49xxxxx <em>ohne Leerstellen</em> ein.
        </div>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    type: {
      default: "text"
    },
    placeholder: {
      default: ""
    }
  },

  data() {
    return {
      splitValues: this.value.split(/,\s*/)
    };
  },

  computed: {
    pattern() {
      return this.type == "tel" ? /^(\+\d+|)$/ : /^.*$/;
    },
    allInputsValid() {
        let allValid = true;
        // important: Let VUE detect that we accessed every element (for updating)
        this.splitValues.forEach(val => allValid &= this.pattern.test(val));
        return allValid;
    }
  },

  methods: {
    updateValue(index, target) {
      let cleanNewValue = target.value.trim();
      let newSplitValues = this.splitValues;
      // Do not use array index access in vue
      newSplitValues.splice(index, 1, cleanNewValue);
      if (cleanNewValue !== target.value) {
        target.value = cleanNewValue;
      }
      this.emitUpdate();
    },
    doRemove(index) {
      this.splitValues.splice(index, 1);
      this.emitUpdate();
    },
    doAdd(index) {
      this.splitValues.splice(index + 1, 0, "");
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit(
        "input",
        this.splitValues
          .map(val => val.trim())
          .filter(val => val != "")
          .join(", ")
      );
    }
  }
};
</script>
